export default "__VITE_ASSET__DTrye_ww__"